var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header-view',[_c('template',{slot:"title"},[_vm._v("My Account")]),(_vm.displayMainMenu)?_c('template',{slot:"profile"},[_c('main-menu',{attrs:{"session":_vm.session,"products":_vm.products}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }